import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { LayoutDirective } from "@ngbracket/ngx-layout/flex";

export interface PasswordExpirationDialogData
{
    readonly expirationMessage: string;
}

@Component({
    selector: "password-expiration-dialog-component",
    templateUrl: "./passwordExpirationDialog.tmpl.html",
    styleUrls: [
        "./passwordExpirationDialog.component.scss"
    ],
    imports: [
        CdkScrollable,
        LayoutDirective,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
    ]
})
export class PasswordExpirationDialogComponent
{
    private readonly data = inject<PasswordExpirationDialogData>(MAT_DIALOG_DATA);


    get expirationMessage(): string
    {
        return this.data.expirationMessage;
    }
}
